import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { CategoryModel } from 'src/app/models/Category.model';
import { NewsService } from 'src/app/services/News/news.service';
import { NewsDashboard } from '../../news-dashboard/news-dashboard.page';
import { NewsFilterComponent } from '../news-filter-component/news-filter-component.component';

@Component({
	selector: 'app-news-card-list',
	templateUrl: './news-card-list.component.html',
	styleUrls: ['./news-card-list.component.scss'],
	standalone: false,
})
export class NewsCardListComponent implements OnInit {
	constructor(
		private newsService: NewsService,
		private newsDashboardPage: NewsDashboard,
		private routeParams: ActivatedRoute,
		public router: Router,
		private popoverController: PopoverController,
		public translate: TranslateService,
	) {}

	@Input() title: string = '';
	@Input() color: any;
	@Input() labelColor: string = '';
	@Input() icon: string = '';
	@Input() route: any;
	@Input() redirect?: string | null;
	@Input() topbar: Boolean = false;
	@Input() back: Boolean = false;
	@Input() categories: Boolean = false;
	@Input() categoryId? = '';
	@Input() recents?: Boolean;
	@Input() notFound? = false;
	@Input() empty? = false;
	@Input() loading? = false;
	@Input() moreButton: Boolean = false;
	@Input() dashboard? = false;
	@Input() relatedNews? = false;
	@Input() highlight: boolean = false;
	@Input() border = false;
	@Input() viewMore: boolean = true;
	@Input() shadow: boolean = true;

	private readonly emptyCategory = new CategoryModel({ name: { pt: '', en: '', es: '' } });
	listCategories: CategoryModel[] = [new CategoryModel()];
	selectedCategory: CategoryModel = this.emptyCategory;
	fakeElementsLarg = ['', '', '', '', '', ''];

	async ngOnInit() {
		this.loading = false;
		if (this.categories) {
			await this.getCategories();
		}
	}

	async getCategories() {
		this.listCategories = await lastValueFrom(this.newsService.getCategories());
		if (this.categoryId) {
			this.selectedCategory = this.listCategories.find(c => c.id === this.categoryId) || this.emptyCategory;
		}
		this.loading = false;
	}

	async getNewsByCategory(category: CategoryModel) {
		this.loading = true;
		let editorialId = this.routeParams.snapshot.paramMap.get('editorialId');
		let search = this.routeParams.snapshot.paramMap.get('search');

		if (this.dashboard) {
			this.selectedCategory = category;
			await this.newsDashboardPage.getNewsByCategory(
				this.selectedCategory.id ?? '',
				// this.selectedCategory !== null ? this.selectedCategory.id : ''
			);
			this.loading = false;
		} else {
			if (this.redirect) {
				window.location.assign(this.redirect);
			} else {
				await this.router.navigateByUrl(
					`/panel/network/news/news/${editorialId}/${category ? category.id : 'null'}/${search}`,
				);
			}
			this.loading = false;
		}
	}

	async presentPopover(ev: any) {
		const popover = await this.popoverController.create({
			component: NewsFilterComponent,
			event: ev,
			translucent: true,
			componentProps: {
				categories: this.listCategories,
				category: this.selectedCategory,
			},
		});
		await popover.present();

		const { data, role } = await popover.onDidDismiss();
		if (role) {
			return;
		}

		const category = data || this.emptyCategory;
		await this.getNewsByCategory(category);
	}
}
